import { TFunction } from 'i18next';

import { LocationAddressFilterType } from '@/entities/location';
import type { SelectOption } from '@/shared/ui';

import { ConsignmentFormValues } from '../model';

export type AllowedStartingPointTypes =
  | typeof LocationAddressFilterType.CUSTOMER_ADDRESS
  | typeof LocationAddressFilterType.ARRIVAL_PORT_TRANSSHIPMENT
  | typeof LocationAddressFilterType.ARRIVAL_DELIVERY_OR_PICKUP_AT_SITE;

export type AllowedServiceTypes =
  | typeof LocationAddressFilterType.CUSTOMER_ADDRESS
  | typeof LocationAddressFilterType.WAREHOUSE_PICKUP
  | typeof LocationAddressFilterType.STORAGE;

export const getStartingPointTypeOptions = (t: TFunction): SelectOption<AllowedStartingPointTypes>[] => [
  {
    value: LocationAddressFilterType.CUSTOMER_ADDRESS,
    label: t('arrivalType.C')
  },
  {
    value: LocationAddressFilterType.ARRIVAL_PORT_TRANSSHIPMENT,
    label: t('arrivalType.P')
  },
  {
    value: LocationAddressFilterType.ARRIVAL_DELIVERY_OR_PICKUP_AT_SITE,
    label: t('arrivalType.X')
  }
];
//requestStatusName
export const getServiceTypeOptions = (t: TFunction): SelectOption<AllowedServiceTypes>[] => [
  {
    value: LocationAddressFilterType.CUSTOMER_ADDRESS,
    label: t('serviceType.D')
  },
  {
    value: LocationAddressFilterType.WAREHOUSE_PICKUP,
    label: t('serviceType.P')
  },
  {
    value: LocationAddressFilterType.STORAGE,
    label: t('serviceType.S')
  }
];

export const getPriorityOptions = (t: TFunction): SelectOption<ConsignmentFormValues['priority']>[] => [
  {
    value: 'normal',
    label: t('dispatchPriorityName.4')
  },
  {
    value: 'high',
    label: t('dispatchPriorityName.3')
  },
  {
    value: 'urgent',
    label: t('dispatchPriorityName.2')
  }
];
